import getWithToken from './base/get-with-token'

const getSignedUrlAzureV2 = (date, meter_id) =>
  getWithToken(`/devices/download-file-v2`)({ date, meter_id })

export default getSignedUrlAzureV2